module.exports = __webpack_public_path__ + "static/media/our-rootbeer.6fb8d6d4.jpg";